var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_600_102035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6747 12.2417C17.1446 13.4955 16.3154 14.6002 15.2596 15.4595C14.2039 16.3187 12.9537 16.9063 11.6184 17.1707C10.2831 17.4352 8.90337 17.3685 7.59981 16.9766C6.29625 16.5846 5.10854 15.8793 4.14054 14.9223C3.17253 13.9653 2.4537 12.7857 2.04688 11.4867C1.64007 10.1877 1.55766 8.8088 1.80685 7.47059C2.05605 6.13238 2.62927 4.87559 3.47639 3.81009C4.32352 2.74459 5.41876 1.90283 6.66636 1.3584",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 8.99984C18.3333 7.90549 18.1178 6.82185 17.699 5.81081C17.2802 4.79976 16.6664 3.8811 15.8926 3.10728C15.1187 2.33346 14.2001 1.71963 13.189 1.30084C12.178 0.882052 11.0943 0.666504 10 0.666504V8.99984H18.3333Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.f12c3696d4aa146db1ac971d0de877bb.svg";
export { ForwardRef as ReactComponent };